import { IEmployeeErrorData, ITeamEmployee, ILabEmployee } from 'typings/employeeErrorData';

export class EmployeeErrorData implements IEmployeeErrorData {

    teamEmployee: ITeamEmployee;
    labEmployee: ILabEmployee;
    errorDetails: { [id: string]: string };

    constructor(data: IEmployeeErrorData) {
        this.initLabData(data.labEmployee);
        this.errorDetails = data.errorDetails;
        this.initTeamData(data.teamEmployee);
    }

    initTeamData(data: ITeamEmployee): void {
        this.teamEmployee = data;
        this.teamEmployee.hireDate = data?.hireDate ? new Date(data.hireDate) : null;
    }

    initLabData(data: ILabEmployee): void {
        this.labEmployee = data;
        this.labEmployee.dateOfHire = data?.dateOfHire ? new Date(data.dateOfHire) : null; 
    }
}